// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__xnGLL","overlay":"Modal_overlay__VZXDP"};